import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface QualityFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
  selectedMaterial: number | undefined;
  selectedColor: number | undefined;
  selectedInfill: number | undefined;
}

interface QualityFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
  selectedPrinter: number | undefined;
  selectedMaterial: number | undefined;
  selectedColor: number | undefined;
  selectedInfill: number | undefined;
}

export function QualityField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false,
  selectedTechnology,
  selectedPrinter,
  selectedMaterial,
  selectedColor,
  selectedInfill
}: QualityFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );
    
    const printer = technology?.printers.find(
      p => p.id === selectedPrinter
    );

    if (!technology || !printer) return [];

    return printer.nozzle_sizes[0].quality_options.map(quality => ({
      id: quality.id,
      name: quality.label,
      label: `${quality.label} - ${quality.layer_height}mm`
    }));
  }, [selectedTechnology, selectedPrinter]);

  const isDisabled = disabled || 
    !selectedTechnology || 
    !selectedPrinter || 
    !selectedMaterial || 
    !selectedColor ||
    !selectedInfill;

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="quality"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${isDisabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Qualidade
      </label>
      <SelectField
        name="quality"
        label="Qualidade"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        isNext={isNext}
        disabled={isDisabled}
      />
    </div>
  );
} 